import { a as _typeof, _ as _slicedToArray } from '../../dist/slicedToArray-9ebce1ca.browser.esm.js';
import ReactJSXRuntime__default from 'react/jsx-runtime';
import jsxRuntimeDev__default from 'react/jsx-dev-runtime';
import React from 'react';
import { vercelStegaDecode, VERCEL_STEGA_REGEX, vercelStegaSplit, vercelStegaCombine } from '@vercel/stega';
import { _ as _toConsumableArray } from '../../dist/toConsumableArray-5ba6766a.browser.esm.js';
import { Internal, VAL_EXTENSION, FILE_REF_PROP } from '@valbuild/core';
import '../../dist/unsupportedIterableToArray-0ac4ac41.browser.esm.js';

function stegaDecodeString(encodedString) {
  if (!encodedString || typeof encodedString !== "string") return;
  var encodedBits = vercelStegaDecode(encodedString);
  if (encodedBits && _typeof(encodedBits) === "object") {
    if ("origin" in encodedBits && "data" in encodedBits && _typeof(encodedBits.data) === "object" && encodedBits.data && "valPath" in encodedBits.data && typeof encodedBits.data.valPath === "string") {
      return encodedBits.data.valPath;
    }
  }
}

var isIntrinsicElement = function isIntrinsicElement(type) {
  // TODO: think this is not correct, but good enough for now?
  return typeof type === "string";
};
var addValPathIfFound = function addValPathIfFound(type, props) {
  // TODO: increases performance. Unsure about the implications right now - seems to work. Remember to look at RSC and client (and pages/?).
  if (!IS_AUTO_TAG_JSX_ENABLED()) {
    return;
  }
  var valSources = new Set();

  // skip auto-tagging fragments since we can't add attributes to them
  if (type === Symbol["for"]("react.fragment")) {
    return;
  }
  function updateValSources(key, value, props, container) {
    if (!key) {
      return;
    }
    // Prevent prototype pollution
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      console.error('Val: Could not auto tag. Reason: key is "__proto__" or "constructor" or "prototype".');
      return;
    }
    var valPath = stegaDecodeString(value);
    if (valPath) {
      // Found val path - this is a stega encoded string
      // The logic below is as follows:
      //   if this is an intrinsic element (a, div, etc.), add data attrs will be on the DOM element
      //   always add to sources (intrinsic or not)
      //   if this is not an intrinsic element, we pass the stega encoded value downwards until we hit an intrinsic element
      valSources.add(valPath);
      if (isIntrinsicElement(type)) {
        // clean values before adding them to the props
        // we cannot do this
        var cleanValue = vercelStegaSplit(value).cleaned;
        // we do Object.entries earlier over props so props that are arrays have string keys:
        var numberOfKey = Number(key);
        if (Array.isArray(container) && numberOfKey > -1) {
          container[numberOfKey] = cleanValue;
        } else if (typeof key === "string" && !Array.isArray(container)) {
          container[key] = cleanValue;
        } else {
          console.error("Val: Could not auto tag. Reason: unexpected types found while cleaning and / or adding val path data props.");
        }
      } else {
        if (key === "href") {
          // This is a hack to make sure href values in Next Link components are cleaned (seems to be a React Server Component issue?)
          var _cleanValue = vercelStegaSplit(value).cleaned;
          if (typeof key === "string" && !Array.isArray(container)) {
            container[key] = _cleanValue;
            valSources.add(valPath);
          }
        }
      }
    }
  }
  if (props && _typeof(props) === "object") {
    for (var _i = 0, _Object$entries = Object.entries(props); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (typeof value === "string" && value.match(VERCEL_STEGA_REGEX)) {
        updateValSources(key, value, props, props);
      } else if (_typeof(value) === "object" && value !== null) {
        if (key === "style") {
          for (var _i2 = 0, _Object$entries2 = Object.entries(value); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              styleKey = _Object$entries2$_i[0],
              styleValue = _Object$entries2$_i[1];
            if (typeof styleValue === "string" && styleValue.match(VERCEL_STEGA_REGEX)) {
              updateValSources(styleKey, styleValue, props, value);
            }
          }
        } else if (value instanceof Array) {
          for (var _i3 = 0, _Object$entries3 = Object.entries(value); _i3 < _Object$entries3.length; _i3++) {
            var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
              index = _Object$entries3$_i[0],
              item = _Object$entries3$_i[1];
            if (typeof item === "string" && item.match(VERCEL_STEGA_REGEX)) {
              updateValSources(index, item, props, value);
            }
          }
        }
      }
    }
    if (valSources.size > 0 && !props["data-val-path"]) {
      props["data-val-path"] = Array.from(valSources).join(",");
      if (IS_RSC()) {
        props["data-val-rsc"] = "true";
      }
    }
  }
};
function WrapJsx(jsx) {
  if (typeof jsx !== "function") return jsx;
  return function (type, props) {
    addValPathIfFound(type, props);
    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }
    return jsx.call.apply(jsx, [jsx, type, props].concat(rest));
  };
}
function autoTagJSX() {
  var JsxPro = ReactJSXRuntime__default;
  var JsxDev = jsxRuntimeDev__default;

  /**
   * createElement _may_ be called by jsx runtime as a fallback in certain cases,
   * so we need to wrap it regardless.
   *
   * The jsx exports depend on the `NODE_ENV` var to ensure the users' bundler doesn't
   * include both, so one of them will be set with `undefined` values.
   */
  React.createElement = WrapJsx(React.createElement);
  JsxDev.jsx && (/*   */JsxDev.jsx = WrapJsx(JsxDev.jsx));
  JsxPro.jsx && (/*   */JsxPro.jsx = WrapJsx(JsxPro.jsx));
  JsxDev.jsxs && (/*  */JsxDev.jsxs = WrapJsx(JsxDev.jsxs));
  JsxPro.jsxs && (/*  */JsxPro.jsxs = WrapJsx(JsxPro.jsxs));
  JsxDev.jsxDEV && (/**/JsxDev.jsxDEV = WrapJsx(JsxDev.jsxDEV));
  JsxPro.jsxDEV && (/**/JsxPro.jsxDEV = WrapJsx(JsxPro.jsxDEV));
}

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

/**
 * ValEncodedString is a string that is encoded using steganography.
 *
 * This means that there is a hidden / non-visible object embedded in the string.
 * This object includes a path, which is used to automatically tag
 * where the content comes from for contextual editing.
 *
 */

/**
 * RichText is accessible by users (after conversion via useVal / fetchVal)
 **/

function stegaEncode(input, opts) {
  function rec(sourceOrSelector, recOpts) {
    if (recOpts !== null && recOpts !== void 0 && recOpts.schema && isKeyOfSchema(recOpts === null || recOpts === void 0 ? void 0 : recOpts.schema)) {
      return sourceOrSelector;
    }
    if (recOpts !== null && recOpts !== void 0 && recOpts.schema && isLiteralSchema(recOpts === null || recOpts === void 0 ? void 0 : recOpts.schema)) {
      return sourceOrSelector;
    }
    if (recOpts !== null && recOpts !== void 0 && recOpts.schema && isDateSchema(recOpts === null || recOpts === void 0 ? void 0 : recOpts.schema)) {
      return sourceOrSelector;
    }
    if (recOpts !== null && recOpts !== void 0 && recOpts.schema && isUnionSchema(recOpts === null || recOpts === void 0 ? void 0 : recOpts.schema)) {
      if (sourceOrSelector && _typeof(sourceOrSelector) === "object" && recOpts.schema.key && typeof recOpts.schema.key === "string") {
        var _key = sourceOrSelector[recOpts.schema.key];
        if (_key) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          var schema = recOpts.schema.items.find(function (s) {
            if (isObjectSchema(s) && s.items && s.items[recOpts.schema.key]) {
              var keySchema = s.items[recOpts.schema.key];
              if (isLiteralSchema(keySchema)) {
                return keySchema.value === _key;
              } else {
                console.warn("Expected literal schema at key in , but found: ", keySchema, {
                  key: _key,
                  schema: s
                });
              }
            } else {
              console.warn("Expected union containing object schema, but found: ", s);
            }
          });
          if (schema) {
            return rec(sourceOrSelector, {
              path: recOpts.path,
              schema: schema
            });
          }
        }
        // illegal value, return as is
        return sourceOrSelector;
      }
      if (typeof sourceOrSelector === "string" && recOpts.schema.key && typeof recOpts.schema.key !== "string") {
        var _ref;
        return rec(sourceOrSelector, {
          path: recOpts.path,
          schema: (_ref = [recOpts.schema.key]).concat.apply(_ref, _toConsumableArray(recOpts.schema.items)).find(function (s) {
            if (isLiteralSchema(s)) {
              return s.value === sourceOrSelector;
            }
          })
        });
      }
    }
    if (recOpts !== null && recOpts !== void 0 && recOpts.schema && isRichTextSchema(recOpts.schema)) {
      var res = rec(sourceOrSelector);
      if (_typeof(res) === "object" && res !== null) {
        res.valPath = recOpts.path;
      }
      return res;
    }
    if (_typeof(sourceOrSelector) === "object") {
      if (!sourceOrSelector) {
        return null;
      }
      var selectorPath = Internal.getValPath(sourceOrSelector);
      if (selectorPath) {
        var newSchema = Internal.getSchema(sourceOrSelector);
        return rec(opts.getModule && opts.getModule(selectorPath) !== undefined ? opts.getModule(selectorPath) : Internal.getSource(sourceOrSelector), opts.disabled ? undefined : {
          path: selectorPath,
          schema: newSchema === null || newSchema === void 0 ? void 0 : newSchema.serialize()
        });
      }
      if (VAL_EXTENSION in sourceOrSelector) {
        if (sourceOrSelector[VAL_EXTENSION] === "file" && typeof sourceOrSelector[FILE_REF_PROP] === "string") {
          var fileSelector = Internal.convertFileSource(sourceOrSelector);
          var url = fileSelector.url;
          return _objectSpread2(_objectSpread2({}, fileSelector), {}, {
            url: rec(url, recOpts)
          });
        } else if (sourceOrSelector[VAL_EXTENSION] === "remote") {
          var remoteSelector = Internal.convertFileSource(sourceOrSelector);
          var _url = remoteSelector.url;
          return _objectSpread2(_objectSpread2({}, remoteSelector), {}, {
            url: rec(_url, recOpts)
          });
        }
        console.error("Encountered unexpected extension: ".concat(sourceOrSelector[VAL_EXTENSION]));
        return sourceOrSelector;
      }
      if (Array.isArray(sourceOrSelector)) {
        return sourceOrSelector.map(function (el, i) {
          return rec(el, recOpts && {
            path: Internal.createValPathOfItem(recOpts.path, i),
            schema: recOpts.schema.item
          });
        });
      }
      if (!Array.isArray(sourceOrSelector)) {
        var _res = {};
        var entries = Object.entries(sourceOrSelector);
        for (var _i = 0, _entries = entries; _i < _entries.length; _i++) {
          var _entries$_i = _slicedToArray(_entries[_i], 2),
            _key2 = _entries$_i[0],
            value = _entries$_i[1];
          _res[_key2] = rec(value, (recOpts === null || recOpts === void 0 ? void 0 : recOpts.schema) && {
            path: Internal.createValPathOfItem(recOpts.path, _key2),
            schema: isRecordSchema(recOpts.schema) ? recOpts.schema.item : isObjectSchema(recOpts.schema) ? recOpts.schema.items[_key2] : unknownSchema(recOpts.schema)
          });
        }
        return _res;
      }
      console.error("Could not transform source selector: ".concat(_typeof(sourceOrSelector), " (array: ").concat(Array.isArray(sourceOrSelector), ")"), sourceOrSelector);
      return sourceOrSelector;
    }
    if (typeof sourceOrSelector === "string") {
      var _recOpts$schema, _recOpts$schema2;
      if (!recOpts) {
        return sourceOrSelector;
      }
      if ((_recOpts$schema = recOpts.schema) !== null && _recOpts$schema !== void 0 && _recOpts$schema.raw || ((_recOpts$schema2 = recOpts.schema) === null || _recOpts$schema2 === void 0 ? void 0 : _recOpts$schema2.type) === "literal") {
        return sourceOrSelector;
      }
      return vercelStegaCombine(sourceOrSelector, {
        origin: "val.build",
        data: {
          valPath: recOpts.path
        }
      }, false // auto detection on urls and dates is disabled, isDate could be used but it is also disabled (users should use a date schema instead): isDate(sourceOrSelector) // skip = true if isDate
      );
    }
    if (typeof sourceOrSelector === "number" || typeof sourceOrSelector === "boolean") {
      return sourceOrSelector;
    }
    console.error("Unexpected type of source selector: ".concat(_typeof(sourceOrSelector)));
    return sourceOrSelector;
  }
  return rec(input);
}
function isRecordSchema(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "record";
}
function isLiteralSchema(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "literal";
}
function isDateSchema(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "date";
}
function unknownSchema(schema) {
  console.debug("Found unknown schema", schema);
  return schema;
}
function isUnionSchema(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "union";
}
function isKeyOfSchema(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "keyOf";
}
function isRichTextSchema(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "richtext";
}
function isObjectSchema(schema) {
  return (schema === null || schema === void 0 ? void 0 : schema.type) === "object";
}
function stegaClean(source) {
  return vercelStegaSplit(source).cleaned;
}
function getModuleIds(input) {
  var modules = new Set();
  function rec(sourceOrSelector) {
    if (_typeof(sourceOrSelector) === "object") {
      if (!sourceOrSelector) {
        return;
      }
      var selectorPath = Internal.getValPath(sourceOrSelector);
      if (selectorPath) {
        modules.add(selectorPath);
        return;
      }
      if (VAL_EXTENSION in sourceOrSelector) {
        if (sourceOrSelector[VAL_EXTENSION] === "richtext") {
          return;
        }
        if (sourceOrSelector[VAL_EXTENSION] === "file" && typeof sourceOrSelector[FILE_REF_PROP] === "string") {
          return;
        }
        console.error("Encountered unexpected extension: ".concat(sourceOrSelector[VAL_EXTENSION]));
        return sourceOrSelector;
      }
      if (Array.isArray(sourceOrSelector)) {
        sourceOrSelector.forEach(rec);
        return;
      }
      if (!Array.isArray(sourceOrSelector)) {
        for (var _i2 = 0, _Object$entries = Object.entries(sourceOrSelector); _i2 < _Object$entries.length; _i2++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
            value = _Object$entries$_i[1];
          rec(value);
        }
        return;
      }
      console.error("Could not transform source selector: ".concat(_typeof(sourceOrSelector), " (array: ").concat(Array.isArray(sourceOrSelector), ")"), sourceOrSelector);
      return;
    }
    if (typeof sourceOrSelector === "string") {
      return;
    }
    if (typeof sourceOrSelector === "number" || typeof sourceOrSelector === "boolean") {
      return;
    }
    console.error("Unexpected type of source selector: ".concat(_typeof(sourceOrSelector)));
    return;
  }
  rec(input);
  return Array.from(modules);
}

// NOTE: the exports of this file needs to be kept in sync with ValQuickJSRuntime
var isRSC = false;
var autoTagJSXEnabled = false;
function IS_AUTO_TAG_JSX_ENABLED() {
  return autoTagJSXEnabled;
}
function SET_AUTO_TAG_JSX_ENABLED(enabled) {
  autoTagJSXEnabled = enabled;
}
function IS_RSC() {
  return isRSC;
}
function SET_RSC(enabled) {
  isRSC = enabled;
}

export { IS_AUTO_TAG_JSX_ENABLED, IS_RSC, SET_AUTO_TAG_JSX_ENABLED, SET_RSC, autoTagJSX, getModuleIds, stegaClean, stegaDecodeString, stegaEncode };
